const TermsAndConditions = () => (
  <div className="section">
    <h1 className="title text-animation font">Terms &amp; Conditions</h1>

    <div className="section-content">
      <ul className="retail-list">
        <li>Goods once sold shall not be taken back.</li>
        <li>
          Our responsibility ceases once goods leave our factory and return of
          products and money refund not applicable.
        </li>
        <li>Subject to Salem jurisdiction.</li>
        <li>
          We do not take responsibility for transportation payments. The buyer
          should deal directly with the transporter.
        </li>
        <li>
          On arrival of goods, any damage or discrepancy in quality must be
          reported by the buyer within &nbsp;7&nbsp;days&nbsp; <br />(
          <a
            href="mailto:sridhanvantariexports@gmail.com"
            className="text-link"
          >
            sridhanvantariexports@gmail.com
          </a>
          ).
        </li>

        <li>Privacy policy to safeguard customer information.</li>
         <li>Delivery transit period within South India takes 2 to 5,North India takes 4 to 10 days, North East India 11 to 18 Days.</li>
      </ul>
    </div>
  </div>
);

export default TermsAndConditions;
